/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var moyaNotification = MoyaContainer.get('core.notification');
    (function (NotificationType) {
        NotificationType["SUCCESS"] = "success";
        NotificationType["WARNING"] = "warning";
    })(exports.NotificationType || (exports.NotificationType = {}));
    var Favorites = /** @class */ (function () {
        function Favorites() {
        }
        Favorites.run = function () {
            var _this = this;
            this.notificationUrl = document.querySelector('.qn__favorites a').getAttribute('href');
            var buttons = document.querySelectorAll('.toggleFavorite');
            buttons.forEach(function (button) {
                var favoriteItem = {
                    i: button.getAttribute('data-id'),
                    t: button.getAttribute('data-type'),
                    c: button.getAttribute('data-category'),
                };
                if (_this.favoriteExist(favoriteItem, _this.getFavorites())) {
                    // this could be done serverside..
                    button.classList.add('active');
                    _this.swapButtonLang(button);
                }
                util.delegate(button, 'click', ".toggleFavorite", function (event) {
                    var target = event.target;
                    var id = target.getAttribute('data-id');
                    var type = target.getAttribute('data-type');
                    var categoryId = target.getAttribute('data-category');
                    if (target.classList.contains('active')) {
                        _this.removeFavorite(id, type);
                    }
                    else {
                        _this.addFavorite(id, type, categoryId);
                    }
                    target.classList.toggle('active');
                    _this.swapButtonLang(target);
                });
            });
            this.bindShareButtons();
            this.bindShareSelected();
            this.bindAddAll();
        };
        Favorites.swapButtonLang = function (button) {
            button.setAttribute('aria-label', button.classList.contains('active')
                ? button.getAttribute('data-remove')
                : button.getAttribute('data-add'));
        };
        Favorites.removeFavorite = function (id, type) {
            var object = {
                i: id,
                t: type
            };
            var existing = this.getFavorites();
            var favorites = [];
            for (var i = 0; i < existing.length; i++) {
                var existingObject = {
                    i: existing[i].i,
                    t: existing[i].t
                };
                if (!this.objectIsEqual(existingObject, object)) {
                    favorites.push(existing[i]);
                }
            }
            if (favorites.length) {
                this.setCookie(JSON.stringify(favorites));
            }
            else {
                this.removeCookie();
            }
            this.sendNotification(exports.NotificationType.WARNING, this.getRemoveMessage());
        };
        Favorites.addFavorite = function (id, type, categoryId) {
            var favorites = this.getFavorites();
            var obj = {
                i: id,
                t: type
            };
            if (categoryId) {
                obj.c = categoryId;
            }
            if (!this.favoriteExist(obj, favorites)) {
                favorites.push(obj);
                this.setCookie(JSON.stringify(favorites));
                this.sendNotification(exports.NotificationType.SUCCESS, this.getAddMessage());
            }
        };
        Favorites.getFavorites = function () {
            var favorites = this.getCookie();
            return favorites ? JSON.parse(favorites) : [];
        };
        Favorites.objectIsEqual = function (object1, object2) {
            if (object1['c'] === undefined || !object1['c']) {
                object1['c'] = null;
            }
            if (object2['c'] === undefined || !object2['c']) {
                object2['c'] = null;
            }
            var keys1 = Object.keys(object1);
            var keys2 = Object.keys(object2);
            if (keys1.length !== keys2.length) {
                return false;
            }
            for (var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++) {
                var key = keys1_1[_i];
                if (object1[key] !== object2[key]) {
                    return false;
                }
            }
            return true;
        };
        Favorites.getCookie = function () {
            var value = "; " + document.cookie;
            var parts = value.split("; " + this.cookieName + "=");
            if (parts.length === 2) {
                return parts.pop().split(";").shift();
            }
        };
        Favorites.setCookie = function (value) {
            var expires;
            var date = new Date();
            date.setTime(date.getTime() + (this.cookieLifeTime * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
            document.cookie = this.cookieName + "=" + value + expires + "; path=/";
        };
        Favorites.removeCookie = function () {
            var date = new Date();
            date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
            document.cookie = this.cookieName + "=; expires=" + date.toUTCString() + "; path=/";
        };
        Favorites.favoriteExist = function (obj, favorites) {
            for (var i = 0; i < favorites.length; i++) {
                if (this.objectIsEqual(favorites[i], obj)) {
                    return true;
                }
            }
            return false;
        };
        Favorites.sendNotification = function (type, message, addButton) {
            if (addButton === void 0) { addButton = true; }
            var now = new Date();
            if (this.lastNotification && (now.getTime() - this.lastNotification.getTime()) < 500) {
                return;
            }
            this.lastNotification = now;
            var options = {};
            options.message = message;
            if (addButton) {
                var button = {
                    label: this.getButtonLabel(),
                    href: this.getNotificatitionUrl(),
                    classes: ['btn', 'btn-primary', 'btn-small'],
                };
                options.buttons = [button];
            }
            return moyaNotification[type]('', options);
        };
        Favorites.getNotificatitionUrl = function () {
            return this.notificationUrl;
        };
        Favorites.getAddMessage = function () {
            return moya.lang === 'is' ? 'Bætt í uppáhalds' : 'Added to favorites';
        };
        Favorites.getRemoveMessage = function () {
            return moya.lang === 'is' ? 'Fjarlægt úr uppáhalds' : 'Removed from favorites';
        };
        Favorites.getButtonLabel = function () {
            return moya.lang === 'is' ? 'Skoða uppáhalds' : 'View favorites';
        };
        Favorites.getCreateLinkSuccessMessage = function () {
            return moya.lang === 'is'
                ? 'Hlekkur á uppáhalds búinn til'
                : 'Favorites link created';
        };
        Favorites.getCreateLinkErrorMessage = function () {
            return moya.lang === 'is'
                ? 'Ekki tókst að búa til hlekk, reyndu aftur síðar'
                : 'Could not create link, try again later.';
        };
        Favorites.getCopyToClipboardSuccessMessage = function () {
            return moya.lang === 'is'
                ? 'Hlekkur afritaður!'
                : 'Link copied!';
        };
        Favorites.getCopyToClipboardErrorMessage = function () {
            return moya.lang === 'is'
                ? 'Ekki tókst að afrita hlekk...'
                : 'Could not copy the link to clipboard...';
        };
        Favorites.bindShareButtons = function () {
            var _this = this;
            document.querySelectorAll('.shareCheck').forEach(function (button) {
                button.addEventListener('click', function () {
                    button.classList.toggle('checked');
                    if (button.classList.contains('category')) {
                        button.closest('div.category').querySelectorAll('.card__item .share').forEach(function (b) {
                            if (button.classList.contains('checked')) {
                                b.classList.add('checked');
                            }
                            else {
                                b.classList.remove('checked');
                            }
                        });
                    }
                    _this.updateSelectedCount();
                });
            });
        };
        Favorites.updateSelectedCount = function () {
            var shareSelectedCounter = document.querySelectorAll('.shareSelected');
            shareSelectedCounter.forEach(function (button) {
                var span = button.querySelector('span');
                var counter = document.querySelectorAll('.card__item .share.checked').length;
                span.textContent = String(counter);
                if (counter > 0) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
            });
        };
        Favorites.bindShareSelected = function () {
            var _this = this;
            MoyaEventHandler.on('modal.show', function (e) {
                if (!e.modal.element.parentElement.classList.contains('favorites')) {
                    return;
                }
                var wrapper = e.modal.element.querySelector('.favorites__createLink');
                if (!wrapper) {
                    return;
                }
                var name = wrapper.querySelector('#linkName');
                name.addEventListener('keyup', function () {
                    if (name.value) {
                        wrapper.classList.add('ready');
                    }
                    else {
                        wrapper.classList.remove('ready');
                    }
                });
                var createButton = wrapper.querySelector('#favoritesCreate');
                createButton.addEventListener('click', function () {
                    wrapper.classList.add('creating');
                    _this.createLink(wrapper, name.value);
                });
            });
        };
        Favorites.createLink = function (wrapper, name) {
            var _this = this;
            var url = wrapper.dataset.url;
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhr.onload = function () {
                if (xhr.status === 200) {
                    var response = JSON.parse(xhr.responseText);
                    _this.linkCreated(wrapper, name, response.url);
                    return;
                }
                console.error(xhr.responseText);
                _this.sendNotification(exports.NotificationType.WARNING, _this.getCreateLinkErrorMessage(), false);
                return;
            };
            xhr.send('name=' + name + '&data=' + JSON.stringify(this.getSelectedFavorites()));
        };
        Favorites.linkCreated = function (wrapper, name, url) {
            var _this = this;
            this.sendNotification(exports.NotificationType.SUCCESS, this.getCreateLinkSuccessMessage(), false);
            wrapper.classList.remove('creating');
            wrapper.classList.add('created');
            wrapper.querySelector('.name label').innerHTML = name;
            var input = wrapper.querySelector('.name input');
            input.value = url;
            var openLink = wrapper.querySelector('.name a.open');
            openLink.href = url;
            wrapper.querySelector('#favoritesCopyLink').addEventListener('click', function () {
                _this.copyToClipboard(input);
            });
        };
        /**
         * Copies the text passed as param to the system clipboard
         * Check if using HTTPS and navigator.clipboard is available
         * Then uses standard clipboard API, otherwise uses fallback
         */
        Favorites.copyToClipboard = function (input) {
            if (window.isSecureContext && navigator.clipboard) {
                navigator.clipboard.writeText(input.value);
                this.sendNotification(exports.NotificationType.SUCCESS, this.getCopyToClipboardSuccessMessage(), false);
            }
            else {
                input.focus();
                input.select();
                try {
                    document.execCommand('copy');
                    this.sendNotification(exports.NotificationType.SUCCESS, this.getCopyToClipboardSuccessMessage(), false);
                }
                catch (err) {
                    console.error('Unable to copy to clipboard', err);
                    this.sendNotification(exports.NotificationType.SUCCESS, this.getCopyToClipboardErrorMessage(), false);
                }
                input.blur();
            }
        };
        Favorites.getSelectedFavorites = function () {
            var data = [];
            document.querySelectorAll('.toy__favorites .card__item .share.checked').forEach(function (check) {
                var button = check.closest('.card__item').querySelector('.toggleFavorite');
                var favoriteItem = {
                    i: button.getAttribute('data-id'),
                    t: button.getAttribute('data-type'),
                    c: button.getAttribute('data-category'),
                };
                data.push(favoriteItem);
            });
            return data;
        };
        Favorites.bindAddAll = function () {
            var _this = this;
            var addAll = document.querySelector('#favoritesView button.addAll');
            if (!addAll) {
                return;
            }
            addAll.addEventListener('click', function () {
                _this.sendNotification(exports.NotificationType.SUCCESS, _this.getAddMessage());
                document.querySelectorAll('#favoritesView .card__item .toggleFavorite').forEach(function (target) {
                    var id = target.getAttribute('data-id');
                    var type = target.getAttribute('data-type');
                    var categoryId = target.getAttribute('data-category');
                    if (!target.classList.contains('active')) {
                        _this.addFavorite(id, type, categoryId);
                        target.classList.toggle('active');
                        _this.swapButtonLang(target);
                    }
                });
                var mapFavorites = document.querySelector('.map__wrap.favorites');
                if (mapFavorites && mapFavorites.dataset.favorites) {
                    var data = JSON.parse(mapFavorites.dataset.favorites);
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        if (item.i && item.t) {
                            _this.addFavorite(item.i, item.t, item.c);
                        }
                    }
                }
            });
        };
        Favorites.cookieName = 'favorites';
        Favorites.cookieLifeTime = 30;
        return Favorites;
    }());
    Favorites.run();

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
